import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboardreact = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "replace",
	stroke: "replace",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 5,
			width: 9,
			height: 9,
			rx: 2,
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18,
			y: 5,
			width: 9,
			height: 9,
			rx: 2,
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 18,
			width: 9,
			height: 9,
			rx: 2,
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18,
			y: 18,
			width: 9,
			height: 9,
			rx: 2,
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		})
	]
});
export default SvgDashboardreact;
